import { render, staticRenderFns } from "./pricing-json-editor.vue?vue&type=template&id=0cb945a5&scoped=true"
import script from "./pricing-json-editor.vue?vue&type=script&lang=js"
export * from "./pricing-json-editor.vue?vue&type=script&lang=js"
import style0 from "./pricing-json-editor.vue?vue&type=style&index=0&id=0cb945a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb945a5",
  null
  
)

export default component.exports